import cssesc from 'cssesc';
import { COMPONENT_ID_PREFIX } from '../constants';
const getComponentId = componentName => cssesc(`${COMPONENT_ID_PREFIX}${componentName.replace(/\s+/g, '-')}`, {
  isIdentifier: true
});
export default getComponentId;
//# sourceMappingURL=get-component-id.js.map